// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__4ernq","fullView":"styles_fullView__1brve"};